<script setup>
import { pickFields } from '../../common/pick-fields.js';
import Icon from '../Icon.vue';

const emit = defineEmits(['update:modelValue', 'selected'])
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

function getOptionId(valueId){
    return `${props.name}-${valueId}`
}

function onOptionClick(option){
    if(option.id !== props.modelValue.id){
        emit('update:modelValue', pickFields(option, Object.keys(props.modelValue)))
    }

    emit('selected')
}

</script>

<template>
    <div
        class="ConfiguratorSelect ConfiguratorOption tw-border-t tw-border-gray-100 last:tw-border-b"
        v-for="option in props.options"
        :key="option.id"
    >

        <label
            class="ConfiguratorSelectLabelType tw-cursor-pointer tw-flex tw-w-full tw-justify-between tw-items-center tw-text-gray-700 tw-text-xl md:tw-text-xl lg:tw-text-2xl tw-font-medium tw-py-4 md:tw-py-6"
            :for="getOptionId(option.id)"
        >
            <input
                type="radio"
                :value="getOptionId(option.id)"
                :id="getOptionId(option.id)"
                :name="props.name"
                :checked="props.modelValue.id === option.id"
                @click="onOptionClick(option)"
                class="tw-sr-only"
            />
            <span v-text="option.title"></span>

            <div>
                <Icon name="chevron-right" class="tw-text-brand-500 tw-size-3" />
            </div>
        </label>
    </div>
</template>